import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat, dateToPlainFormat } from '@/utils'

export interface PreferenceAssignReserve {
  id: number
  rank: number
  userId: string
  name: string
  reserveRegistrationTime: string
  collectionId: number
  preferredDate: string
  reserveExpiration: string
  reserveSpecifyBranchCodes: SystemCode[]
  reserveSetId: number
  reserveSetRank: number
  reserveGroupId: number
  reserveRegistrationBranchCode: SystemCode
  reserveRegistrationPlaceCode: SystemCode
  forwardingBranchCode: SystemCode
  specifyCollectionId: number
  specifyCollectionNo: string
  reserveStatus: SystemCode
  reserveNoticeAllowed: boolean
  displayMemo: string
  contactMethod: SystemCode
  revision: number
  isAssignableReserve: boolean
}

export function PreferenceAssignReserveFromJSON(
  json: any
): PreferenceAssignReserve {
  return {
    id: exists(json, 'id') ? json.id : 0,
    rank: exists(json, 'rank') ? json.rank : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    reserveRegistrationTime: exists(json, 'reserve_registration_time')
      ? dateTimeToPlainFormat(json.reserve_registration_time)
      : '',
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    preferredDate: exists(json, 'preferred_date')
      ? dateToPlainFormat(json.preferred_date)
      : '',
    reserveExpiration: exists(json, 'reserve_expiration')
      ? dateToPlainFormat(json.reserve_expiration)
      : '',
    reserveSpecifyBranchCodes: exists(json, 'reserve_specify_branch_codes')
      ? json.reserve_specify_branch_codes.map(SystemCodeFromJSON)
      : [],
    reserveSetId: exists(json, 'reserve_set_id') ? json.reserve_set_id : 0,
    reserveSetRank: exists(json, 'reserve_set_rank')
      ? json.reserve_set_rank
      : 0,
    reserveGroupId: exists(json, 'reserve_group_id')
      ? json.reserve_group_id
      : 0,
    reserveRegistrationBranchCode: exists(
      json,
      'reserve_registration_branch_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_branch_code)
      : defaultSystemCode(),
    reserveRegistrationPlaceCode: exists(
      json,
      'reserve_registration_place_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_place_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    specifyCollectionId: exists(json, 'specify_collection_id')
      ? json.specify_collection_id
      : 0,
    specifyCollectionNo: exists(json, 'specify_collection_no')
      ? json.specify_collection_no
      : '',
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    reserveNoticeAllowed: exists(json, 'reserve_notice_allowed')
      ? json.reserve_notice_allowed
      : false,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    contactMethod: exists(json, 'contact_method')
      ? SystemCodeFromJSON(json.contact_method)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0,
    isAssignableReserve: exists(json, 'is_assignable_reserve')
      ? json.is_assignable_reserve
      : false
  }
}
